export default {
  apiUrl: {
    teplUrl: {
      searchTemplateModule: "/decorate/templateModule/searchTemplateModule", //查询模板接口
      searchModuleInfo: "/decorate/moduleInfo/searchModuleInfo", //查询模块详情
      addModuleInfo: "/decorate/moduleInfo/addModuleInfo", //添加图片模块
      modifyModuleInfo: "/decorate/moduleInfo/modifyModuleInfo", //修改图片模块
      goodsList: "/goods/item/getListMerchantItemDto", //商品列表
      goodsDetail: "/goods/item/findItems", //商品详情多个
      addModuleGoods: "/decorate/moduleGoods/addModuleGoods", //添加模块商品
      searchModuleGoods: "/decorate/moduleGoods/searchModuleGoods", //查询模块商品
      modifyModuleGoods: "/decorate/moduleGoods/modifyModuleGoods", //修改模块商品
      removeModuleGoods: "/decorate/moduleGoods/removeModuleGoods", //删除模块商品
      addTemplateTitle: "/decorate/templateTitle/addTemplateTitle", //添加标题
      searchTemplateTitle: "/decorate/templateTitle/searchTemplateTitle", //查询标题
      modifyTemplateTitle: "/decorate/templateTitle/modifyTemplateTitle", //修改标题
      searchTitleGoods: "/decorate/titleGoods/searchTitleGoods", //查询标题商品
      modifyTitleGoods: "/decorate/titleGoods/modifyTitleGoods", //添加标题商品
      removeTitleGoods: "/decorate/titleGoods/removeTitleGoods", //删除标题商品
      removeTemplateTitle: "/decorate/templateTitle/removeTemplateTitle", //删除标题
      addSecondTitle: "/decorate/templateTitle/addSecondTitle", //添加二级标题
      appHomePage: "/decorate/appHomePage/search", //查询模板接口
      updateHomeComponent: "/decorate/app/homePage/updateComponent", // 保存首页组件
      searchHomeComponent: "/decorate/app/homePage/searchComponent/", // 查询首页组件
      timeElevator:'/decorate/app/homePage/timeElevator/labelItems',  //首頁時間電梯組建獲取商品

    }
  }
};
